// This is just some sample data so you don't have to think of your own!
const fishes = {
  fish1: {
    name: "The 4-HOUR WORK WEEK",
    image: "/images/work.jpg",
    desc:
      "The 4-Hour Workweek is a new way of solving a very old problem: just how can we work to live and prevent our lives from being all about work?",
    price: 168,
    status: "unavailable"
  },

  fish2: {
    name: "The Magic of Big Thinking",
    image: "/images/magic.jpg",
    desc:
      "Believe in yourself, never underestimate your own intelligence, think positively, and plan for success",
    price: 143,
    status: "available"
  },

  fish3: {
    name: "The sceince of getting rich",
    image: "/images/science.jpg",
    desc:
      "The Science of Getting Rich can do for you today what it has been doing for successful men and women of all ages, from all walks of life.",
    price: 172,
    status: "available"
  },

  fish4: {
    name: "The Art of Thinking Clearly",
    image: "/images/artOf.jpg",
    desc:
      "The Art of Thinking Clearly by world-class thinker and entrepreneur Rolf Dobelli is an eye-opening look at human psychology and reasoning  ",
    price: 1129,
    status: "available"
  },

  fish5: {
    name: "Self Discipline",
    image: "/images/self.jpg",
    desc:
      "Develop Daily Habits to Program Your Mind, Build Mental Toughness, Self-Confidence and Willpower ",
    price: 434,
    status: "available"
  },

  fish6: {
    name: "The Man Search for meaning",
    image: "/images/meaning.jpg",
    desc:
      "Frankl's Man's Search for Meaning provides a vivid account of an individual's experience as a prisoner in a Nazi concentration camp.",
    price: 320,
    status: "available"
  },

  fish7: {
    name: "Thinking Fast and Slow",
    image: "/images/thinking.jpg",
    desc: "Thinking, Fast and Slow, Kahneman takes us on a groundbreaking tour of the mind and explains the two systems that drive the way..",
    price: 2543,
    status: "available"
  },

  fish8: {
    name: "The 7 habits",
    image: "/images/habbits.jpg",
    desc:
      "Covey presents an approach to being effective in attaining goals",
    price: 425,
    status: "available"
  },

};

export default fishes;
